<script>
import AppointmentStore from "../../../mixins/appointment-store";

export default {
    name: "ContactInfo",

    mixins: [AppointmentStore],

    props: {
        contactText: String
    },

    methods: {
        setMakeAndModel() {
            if (!this.appointmentStore.hasVehicleData) {
                return;
            }

            this.appointmentStore.formData.make_and_model = `${this.appointmentStore.vehicleData.merk} ${this.appointmentStore.vehicleData.handelsbenaming}`
        }
    },

    created() {
        this.setMakeAndModel()
        this.appointmentStore.setSessionToken()
    }
}
</script>

<template>
    <div class="vue-contact-info">
        <div class="intro">
            <div v-html="contactText"></div>
        </div>

        <form @submit.prevent="appointmentStore.submitAppointment()">
            <fieldset class="row">
                <legend class="col-12 virtual-h4 mb-3">Persoonsgegevens</legend>

                <div class="col-12 col-md-6 form-item">
                    <label for="first_name">
                        Voornaam <span class="required-mark">*</span>
                    </label>
                    <input v-model="appointmentStore.formData.first_name" id="first_name" name="first_name" required
                           type="text" class="d-block w-100">
                </div>
                <div class="col-12 col-md-6 form-item">
                    <label for="last_name">
                        Achternaam <span class="required-mark">*</span>
                    </label>
                    <input v-model="appointmentStore.formData.last_name" id="last_name" name="last_name" required
                           type="text" class="d-block w-100">
                </div>

                <div class="col-12 form-item">
                    <label for="email_address">
                        E-mailadres<span class="required-mark">*</span>
                    </label>
                    <input v-model="appointmentStore.formData.email_address" id="email_address" name="email_address"
                           required type="email" class="d-block w-100">
                </div>

                <div class="col-12 form-item">
                    <label for="phone_number">
                        Telefoonnummer
                    </label>
                    <input v-model="appointmentStore.formData.phone_number" id="phone_number" name="phone_number"
                           type="tel" class="d-block w-100">
                </div>

                <div class="col-12 col-lg-4 form-item">
                    <label for="zip_code">
                        Postcode<span class="required-mark">*</span>
                    </label>
                    <input v-model="appointmentStore.formData.zip_code" id="zip_code" name="zip_code" required
                           type="text" class="d-block w-100">
                </div>

                <div class="col-12 col-md-6 col-lg-4 form-item">
                    <label for="house_number">
                        Huisnummer<span class="required-mark">*</span>
                    </label>
                    <input v-model="appointmentStore.formData.house_number" id="house_number" name="house_number"
                           required type="text" class="d-block w-100">
                </div>

                <div class="col-12 col-md-6 col-lg-4 form-item">
                    <label for="house_number_addition">
                        Toevoeging
                    </label>
                    <input v-model="appointmentStore.formData.house_number_addition" id="house_number_addition"
                           name="house_number_addition" type="text" class="d-block w-100">
                </div>

                <div class="col-12 form-item">
                    <label for="street">
                        Straatnaam <span class="required-mark">*</span>
                    </label>
                    <input v-model="appointmentStore.formData.street" id="street" name="street" required type="text"
                           class="d-block w-100">
                </div>

                <div class="col-12 form-item">
                    <label for="city">
                        Plaats <span class="required-mark">*</span>
                    </label>
                    <input v-model="appointmentStore.formData.city" id="city" name="city" required type="text"
                           class="d-block w-100">
                </div>
            </fieldset>
            <fieldset class="row">
                <legend class="col-12 virtual-h4 mb-3">Gegevens van uw auto</legend>

                <div class="col-12 form-item">
                    <label for="mileage">
                        Kilometerstand <span class="required-mark">*</span>
                    </label>
                    <input v-model="appointmentStore.formData.mileage" id="mileage"
                           placeholder="Huidige kilometerstand (alleen cijfers)" name="mileage" min="0" required
                           type="number" class="d-block w-100">
                </div>

                <div class="col-12 form-item">
                    <label for="make_and_model">
                       Merk en model <span class="required-mark">*</span>
                    </label>
                    <input v-model="appointmentStore.formData.make_and_model" id="make_and_model" name="make_and_model"
                           required type="text" class="d-block w-100">
                </div>

                <div class="col-12 form-item">
                    <label for="comments">
                       Opmerkingen (optioneel)
                    </label>
                    <textarea v-model="appointmentStore.formData.comments" name="comments" id="comments" rows="6"
                              class="d-block w-100"></textarea>
                </div>

                <div class="col-12 form-item">
                    <p>Door op aanvraag voltooien te klikken gaat u akkoord met onze <a href="/node/3390">algemene
                        Voorwaarden</a></p>

                    <button type="submit" class="btn-arrow">
                        Aanvraag voltooien
                    </button>
                </div>

                <div class="col-12 mt-4" v-if="appointmentStore.formError">
                    <div class="alert alert-danger alert-dismissible" role="alert">
                        Er is iets fout gegaan bij het versturen van uw aanvraag. Probeer het later opnieuw.

                        <button type="button" @click.stop="appointmentStore.formError = false" class="close"
                                data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</template>